import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import KuposModal from './KuposModal';
import SvgHome from './SvgHome';

export class KuposImageSlider extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  onImageClick = image => {
    console.log('Inside image click--------------', image);
    this.setState({ currentImage: image, showModal: true });
  };

  render() {
    return (
      <div className="common-kupos-image-slider">
        <Carousel
          showArrows={true}
          showThumbs={false}
          showStatus={false}
          infiniteLoop={true}
          stopOnHover={true}
          autoPlay={this.props.autoPlay}
          interval={this.props.interval}
        >
          {this.props.images &&
            this.props.images.map((val, key) => {
              return (
                //  <div key={key} onClick={() => this.props.onClick(val)}>
                <div key={key} onClick={() => this.onImageClick(val)}>
                  <img src={val} />
                </div>
              );
            })}
        </Carousel>

        {this.state.currentImage && (
          <KuposModal
            ariaLabel="modal-outer"
            size={'lg'}
            // onHide={() =>
            //   this.setState({
            //     showModal: false,
            //   })
            // }
            // backdrop={() =>
            //   this.setState({
            //     showModal: false,
            //   })
            // }
            showModal={this.state.showModal}
          >
            <div className="tnc-pnr-modal">
              <div>
                <img src={this.state.currentImage} />
              </div>
              <div
                className="close-button pointer"
                onClick={() => this.setState({ showModal: false })}
                // onClick={() => this.setState({ showModal: false })}
              >
                <SvgHome name="close" />
              </div>
            </div>
          </KuposModal>
        )}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(KuposImageSlider);



// WEBPACK FOOTER //
// ./src/features/common/KuposImageSlider.js